import {menusNavigation} from '@/store';

export default function changeStatus(status = true) {
  const tab = menusNavigation.tabs.find(tab => tab.tab === 'MemberList');
  tab.isEditing = status;
}
